define(
    'viewmodels/secured/explorer/details/tabs/actions/actionsDocumentLinks/actionsDocumentLinks',[
        "viewmodels/ViewModel",
        "services/service.documents",
        "i19n!i19n/strings",
        "plugins/router",
        "services/config",
        "providers/dataprovider"
    ],
    function (ViewModel, documentService, i19n, router, config, dataProvider) {

        var vm = new ViewModel(
        {
            i19n: i19n,
            items: ko.observable([]),
            generateItems: ko.observable([]),
            itemsPublished: ko.observable([]),
            hasHighest: ko.observable(false)
        });

        vm.activate = function () {
            var d = $.Deferred();

            vm.items([]);
            vm.generateItems([]);
            vm.itemsPublished([]);
            vm.hasHighest(false);

            var i = sessionStorage.getItem("documentlinks");

            if (i) {
                //console.warn($.parseJSON(i));
                var items = _.map($.parseJSON(i), function (itm) {
                    return {
                        docIdVersionId: itm.documentId, //as per chris
                        documentId: itm.documentId,
                        filename: itm.title ? (itm.title + ' (' + itm.docIdVersion + ')' + '.' + itm.extension) : itm.documentId,
                        link: window.location.origin + window.location.pathname + "#download/" + itm.documentId
                    };
                });                                

                dataProvider.documents
                .actions.canDownload(items)
                .done(function (data) {
                    if (data.success) {

                        items = _.sortBy(items, 'filename');

                        vm.items(items);

                        dataProvider.documents
                        .getDocumentHpvLinks(items)
                        .done(function (data) {
                            if (data.documentLinks.length > 0) {
                                var items = _.map(data.documentLinks, function (itm) {
                                    return {
                                        documentId: itm.documentId,
                                        filename: itm.documentLinkTitle,
                                        link: itm.documentLinkUrl
                                    };
                                });

                                items = _.sortBy(items, 'filename');

                                vm.itemsPublished(items);
                                vm.hasHighest(true);
                            }
                        })
                        .fail(function (e) {
                            console.error(e);
                        })
                        .always(function () {
                            d.resolve();
                        });

                    } else {
                        d.resolve();
                    }
                })
                .fail(function (e) {
                    console.error(e);

                    d.resolve();
                });
            } else {
                d.resolve();
            }

            return d.promise();
        };
        vm.attached = function () {
            
        };
        vm.generateLinksClick = function () {
            var expiry = $("#selectExpiry").val();

            var items = _.map(vm.items(), function (itm) {
                return {documentId: itm.documentId};
            });
            
            var p = {
                shareexpiryhours: expiry,
                documents: items
            };

            dataProvider.documents
            .getDocumentPublicLinks(p)
            .done(function (data) {
                if (data.documentLinks.length > 0) {
                    var items = _.map(data.documentLinks, function (itm) {
                        return {
                            filename: itm.documentLinkTitle,
                            link: itm.documentLinkUrl
                        };
                    });

                    items = _.sortBy(items, 'filename');
                    
                    vm.generateItems(items);
                }
            })
            .fail(function (e) {
                console.error(e);
            });

        };
        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };

        return vm;
    });
